import type { ConceptDef } from '../types';

export const moreVsLess: ConceptDef = {
  kind: 'tileMatch',
  id: 'more-vs-less',
  label: 'More vs Less',
  category: 'Math',
  description: 'Hear a question about more or less; tap the answer.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Which is more: five or three?', answer: '5' },
      { say: 'Which is less: four or seven?', answer: '4' },
      { say: 'Which is more: two or six?', answer: '6' },
      { say: 'Which is less: nine or five?', answer: '5' },
      { say: 'Which is more: eight or three?', answer: '8' },
    ],
  },
};
